import { jsx } from '@amazon/vinyl-tsx'
import { data, type ObservableValue } from '@amazon/vinyl-observable'
import { isMobile, isTv } from '@/device/deviceConfig'
import { mediaQuery$ } from '@/util/mediaQuery'

/**
 * Whether the app lays out for a phone: a window at GH's mobile screen size (Bauhaus
 * `maxBreakpoint('MD')`, up to 639px wide) or a phone at any width. A TV never does.
 */
export function phoneLayout$(): ObservableValue<boolean> {
    if (isTv()) return data(false)
    if (isMobile()) return data(true)
    return mediaQuery$('(max-width: 639px)')
}

interface PhoneLayoutSwitchProps {
    readonly render: (phone: boolean) => HTMLElement | null
}

/** Renders `render(phone)` for the current layout and re-renders when the window crosses into or out of it. */
export function PhoneLayoutSwitch(props: PhoneLayoutSwitchProps) {
    const phone$ = phoneLayout$()
    let shown = phone$.value
    return (
        <div
            className="phoneLayoutSwitch"
            onConnect={(el) =>
                phone$.onData((phone) => {
                    if (phone === shown) return
                    shown = phone
                    const child = props.render(phone)
                    el.replaceChildren(...(child ? [child] : []))
                })
            }
        >
            {props.render(shown)}
        </div>
    )
}
